<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['data', 'labels', 'height'],
  methods: {
    montarGrafico () {
      this.renderChart({
        labels: this.labels,
        datasets: this.data
      }, {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            display: false,
            categoryPercentage: 1,
            barPercentage: 0.5
          }],
          yAxes: [{
            display: false
          }]
        }
      })
    }
  },
  watch: {
    'labels': function () {
      this.montarGrafico()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/dashboard/CardBarChartExample.vue